import { useRef, useState, useEffect } from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShareNodes } from '@fortawesome/free-solid-svg-icons'

import {
    WeiboShareButton,
    WeiboIcon,
    WhatsappShareButton,
    WhatsappIcon,
    TwitterShareButton,
    XIcon,
    FacebookShareButton,
    FacebookIcon
} from "react-share";
import { useLocation } from "react-router-dom"
export default function Pop(props) {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false)
    const clickMeButtonRef = useRef();
    const [shares, setShares] = useState([]);
    const location = useLocation();

    useEffect(() => {
        setShares([
            {
                button: <FacebookShareButton
                    url={`${process.env.REACT_APP_SHARE_DOMAIN}${location.pathname}`}
                    quote={props.title}
                >
                    <FacebookIcon size={44} round iconFillColor={'#2a67b4'} bgStyle={{ fill: 'white' }} />
                </FacebookShareButton>
            },
            {
                button: <TwitterShareButton
                    url={`${process.env.REACT_APP_SHARE_DOMAIN}${location.pathname}`}
                    title={props.title}
                >
                    <XIcon size={44} round iconFillColor={'#2a67b4'} bgStyle={{ fill: 'white' }} />
                </TwitterShareButton>
            },
            {
                button: <WeiboShareButton
                    url={`${process.env.REACT_APP_SHARE_DOMAIN}${location.pathname}`}
                    title={props.title}
                    image={`${process.env.REACT_APP_SHARE_DOMAIN}/img/intro-bg.png`}
                >
                    <WeiboIcon size={44} round iconFillColor={'#2a67b4'} bgStyle={{ fill: 'white' }} />
                </WeiboShareButton>
            },
            {
                button: <WhatsappShareButton
                    url={`${process.env.REACT_APP_SHARE_DOMAIN}${location.pathname}`}
                    title={props.title}
                    separator=":: "
                >
                    <WhatsappIcon size={44} round iconFillColor={'#2a67b4'} bgStyle={{ fill: 'white' }} />
                </WhatsappShareButton>
            }
        ])
    }, [props.title, location.pathname]);

    return <Popover
        isOpen={isPopoverOpen}
        positions={['bottom']}
        padding={4}
        onClickOutside={() => setIsPopoverOpen(false)}
        ref={clickMeButtonRef} // if you'd like a ref to your popover's child, you can grab one here
        content={({ position, childRect, popoverRect }) => (
            <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                position={position}
                childRect={childRect}
                popoverRect={popoverRect}
                arrowColor={'#2a67b4'}
                arrowSize={10}
                className='mt-2.5 bg-wsd header-container rounded-2xl'
                arrowClassName='header-arrow'
            >
                <div
                    className="mt-1 flex justify-center items-center p-1"
                    onClick={() => setIsPopoverOpen(!isPopoverOpen)}
                >
                    {shares.map((share, idx) => {
                        return <div key={idx} className="mx-1.5">{share.button}</div>
                    })}
                </div>
            </ArrowContainer>
        )}
    >
        <div className="cursor-pointer flex flex-none items-center px-1 pr-0" onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
            <div className={`${!!isPopoverOpen ? 'border-[1px] border-wsd bg-white text-wsd' : 'border-[1px] border-wsd bg-wsd text-white'} px-[9px] py-1 border-1 rounded-full font-meidum`}>
                <FontAwesomeIcon icon={faShareNodes} alt="Open Up The Page Sharing Popover" />
            </div>
        </div>
    </Popover>
}